import { render } from "./PainelEdicao.vue?vue&type=template&id=b3487894&scoped=true"
import script from "./PainelEdicao.vue?vue&type=script&lang=js"
export * from "./PainelEdicao.vue?vue&type=script&lang=js"

import "./PainelEdicao.vue?vue&type=style&index=0&id=b3487894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3487894"]])

export default __exports__